import styled from 'styled-components';

export const Wrapper = styled.div`
  h2 span {
    font-family: ${props => props.theme.fontFamilies.main.regular};
    opacity: ${props => props.theme.opacities.medium};
  }

  p {
    font-weight: bold;
  }
`;

export const Circle = styled.span<StyleProps>`
  background: ${props => props.background};
  border-radius: 50%;
  display: inline-block;
  width: 16px;
  height: 16px;
`;
